// extracted by mini-css-extract-plugin
module.exports = {"root":"Category_root__1qMlp","label":"Category_label__2e_4t","content":"Category_content__6SMCn","header":"Category_header__1_yHh","location":"Category_location__ZuHDJ"};